var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/header";
import "../../components/leftMenu";
import "./daulyDetails.css";
import "../../components/paging";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, "/api/user/myproject", root, {}) || this;
        _this.XiangXi = ko.observable(0);
        _this.popur = ko.observable(0);
        _this.genjin = ko.observable(0);
        _this.qunliao = ko.observable(0);
        _this.qunliaox = ko.observable(0);
        _this.userid = ko.observable(); //用户id
        _this.proinfo = ko.observable(); //项目详细信息
        _this.chatMessageInfo = ko.observable(); //聊天信息
        _this.pid = ko.observable(); //群聊详细信息需要的项目id
        _this.time = ko.observable(); //聊天时间
        return _this;
    }
    HeaderModel.prototype.zkGengDuo = function (m, e) {
        var div = e.currentTarget.parentNode
            .nextElementSibling;
        if (!div.style.display || div.style.display == "block") {
            div.style.display = "none";
        }
        else {
            div.style.display = "block";
        }
    };
    HeaderModel.prototype.XiangXiZK = function (m, e) {
        var div = e.currentTarget.parentNode
            .nextElementSibling.nextElementSibling;
        var div1 = e.currentTarget.parentNode
            .nextElementSibling;
        var div2 = e.currentTarget.lastElementChild;
        if (!div.style.display || div.style.display == "none") {
            div1.style.display = "block";
            div.style.display = "block";
            div2.style.transform = "rotate(0deg)";
        }
        else {
            div1.style.display = "none";
            div.style.display = "none";
            div2.style.transform = "rotate(180deg)";
        }
    };
    HeaderModel.prototype.GenJin = function (m, e) { };
    HeaderModel.prototype.Popur = function (m, e) {
        if (this.popur() == 1) {
            this.popur(0);
        }
        else {
            this.popur(1);
        }
    };
    HeaderModel.prototype.QunLiao = function (m, e) {
        var _this = this;
        this.pid(e.id); //存起来项目id
        this.userid(this.data.userId); //加载头像用的用户id
        //console.log(this.userid()+'---------用户id-----------');
        ajax.get('/api/user/chatMessage', { pid: e.id })
            .then(function (d) {
            _this.chatMessageInfo(d.data.messages);
            //this.time(d.data.messages[0].chatDate.replace(/(\d{4}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).(\d{1,2}).+/mg, '$1-$2-$3 $4:$5:$6'));
        });
        if (this.qunliao() == 1) {
            this.qunliao(0);
        }
        else {
            this.qunliao(1);
        }
    };
    //退出群聊
    HeaderModel.prototype.exitchat = function () {
        if (this.qunliao() == 1) {
            this.qunliao(0);
            this.qunliaox(0);
        }
        else {
            this.qunliao(1);
        }
    };
    //群聊项目详细信息
    HeaderModel.prototype.QunLiaoX = function (m, e) {
        var _this = this;
        //console.log(e.id+'---------当前项目id--------');
        ajax.get('/api/project/details', { projectId: this.pid() })
            .then(function (d) {
            _this.proinfo(d.data.details[0]);
        });
        var div = e.currentTarget.lastElementChild;
        if (this.qunliaox() == 1) {
            this.qunliaox(0);
            div.style.transform = "rotate(0deg)";
        }
        else {
            this.qunliaox(1);
            div.style.transform = "rotate(180deg)";
        }
    };
    //定位
    HeaderModel.prototype.location = function (m, d, e) {
        var mapgps;
        setTimeout(function () {
            //let div = document.getElementById(e) as HTMLElement;
            mapgps = d.chatMessage.split(',');
            //.log(mapgps);
            var map = new BMap.Map(e + 'dw2');
            map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), 16);
            map.addControl(new BMap.NavigationControl());
            map.addControl(new BMap.ScaleControl());
            map.addControl(new BMap.OverviewMapControl());
            map.addControl(new BMap.MapTypeControl());
            map.enableScrollWheelZoom(true);
            var new_point = new BMap.Point(mapgps[0], mapgps[1]);
            var marker = new BMap.Marker(new_point); // 创建标注
            map.addOverlay(marker); // 将标注添加到地图中
            map.panTo(new_point);
            var i = 16;
            map.addEventListener("click", function () {
                i = i + 1;
                //console.log(i);
                mapgps = d.chatMessage.split(',');
                //console.log(mapgps);
                var map = new BMap.Map(e + 'dw2');
                map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), i);
                map.enableScrollWheelZoom(true);
                var new_point = new BMap.Point(mapgps[0], mapgps[1]);
                var marker = new BMap.Marker(new_point); // 创建标注
                map.addOverlay(marker); // 将标注添加到地图中
                map.panTo(new_point);
            });
        }, 1000);
    };
    HeaderModel.prototype.top = function () {
        this.data.userId = this.userid();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        this.data.type = 1;
        //this.hm.url='/api/pc/project';
        return this.loadData()
            .then(function (d) {
        });
    };
    HeaderModel.prototype.bottom = function () {
        this.data.userId = this.userid();
        this.data.pageIndex = this.viewModel().data.pageIndex;
        ;
        this.data.type = 0;
        //this.hm.url='/api/pc/project';
        return this.loadData()
            .then(function (d) {
        });
    };
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        return Promise.all([this.loadnum(), this.loadbubble(), this.loadData()]).then(function () { });
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container.querySelector(".Myproject"));
        //this.hm.bind();
    };
    mModel.prototype.update = function (arg) {
        this.hm.data.userId = arg.routeData.query["userId"];
        this.hm.userid(arg.routeData.query["userId"]);
        this.hm.data.pageIndex = 1;
        this.hm.data.type = 0;
        //this.hm.url='/api/pc/project';
        return this.hm.load();
        //.log(this.hm.data.userId+ "-----传进来的用户id-------");
    };
    return mModel;
}(Page));
export default mModel;
